import React, { useEffect, useState } from 'react';
import { Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { useQuery } from 'react-query';
import { getDefaultSettings, getSettings } from '../../NecttosComp/APICaller/ApiServices';
import { Table, Tbody, Td, Th, Thead, Tr } from '../../NecttosComp/Table/Table';
import toast, { Toaster } from 'react-hot-toast';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import Input2 from '../../NecttosComp/Input/Input2';
import { OLoading } from '../../static/svg/icons';
import Instruction from '../../Documentation/Instruction';

function DataBank({ onClose }) {
	let { data: drops = {}, refetch, isLoading } = useQuery(['getDatajBank'], getDefaultSettings('dataBank'));
	const [seletedRole, setSelectedRole] = useState('student');
	const [show, setShow] = useState({ details: false, delete: false, update: false, input: false, new: false, array: false });
	const [seleted, setSelected] = useState({});
	const [selectedRoleCategory, setSelectedRoleCategory] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [searchText, setSearchText] = useState('');
	const [arraycategory, setArrayCategory] = useState([]);
	const [filters, setFilters] = useState({
		_id: '',
		name: '',
		shortName: '',
		category: '',
	});

	

	const columns = [
		{ key: '_id', label: 'ID', filterType: 'text' },
		{ key: 'name', label: 'Name', filterType: 'text' },
		{ key: 'shortName', label: 'Short Name', filterType: 'text' },
		{ key: 'category', label: 'Category', filterType: 'select', options: selectedRoleCategory },
	];

	useEffect(() => {
		if (seletedRole && Object.keys(drops).length > 0) {
			const category = drops[seletedRole]?.map((item) => item.category);
			const uniqueCategory = [...new Set(category)];
			setSelectedRoleCategory(uniqueCategory);
		}
	}, [seletedRole, drops]);
	useEffect(() => {
		if (drops && Object.keys(drops).length > 0 && drops[seletedRole]) {
			let filtered = drops[seletedRole]?.filter((item) => {
				return item?.name?.toLowerCase().includes(searchText?.toLowerCase()) || item?.shortName?.toLowerCase().includes(searchText?.toLowerCase()) || item?.category?.toLowerCase().includes(searchText?.toLowerCase());
			});
			if (filters) {
				Object.keys(filters).forEach((key) => {
					if (filters[key]) {
						filtered = filtered.filter((item) => item[key]?.toLowerCase().includes(filters[key]?.toLowerCase()));
					}
				});
			}
			setFilteredData(filtered);
		} else {
			setFilteredData([]);
		}
	}, [searchText, drops, seletedRole, filters]);

	const handleSelect = (item) => {
		setSelected(item);
		setShow({ details: true });
	};
	const handleClose = (modal) => {
		if (Array.isArray(modal)) {
			setShow({ ...show, ...modal?.map((m) => ({ [m]: false })) });
		} else {
			setShow({ ...show, [modal]: false });
		}
	};

	const handleDelete = async () => {
		try {
			const insatnce = await getAxiosTokenInstance();
			const response = await insatnce.delete('/college/action/deleteSettings', {
				params: { type: 'dataBank', itemId: seleted._id, role: seletedRole },
			});
			if (response.status === 200) {
				toast.success('Item deleted successfully');
				setShow({ delete: false });
				refetch();
			} else {
				toast.error('Error while deleting the item');
			}
		} catch (error) {
			toast.error('Error while deleting the item');
		}
	};

	const handleEdit = async () => {
		const currentList = drops[seletedRole] || [];

		const exists = currentList?.some((x) => x._id === seleted._id);

		const settings = exists ? currentList?.map((item) => (item._id === seleted._id ? { ...seleted } : item)) : [...currentList, seleted];

		try {
			const instance = await getAxiosTokenInstance();
			const response = await instance.post('/college/action/postDefaultSettings', {
				type: 'dataBank',
				settings: settings,
				role: seletedRole,
			});

			if (response.status === 200) {
				toast.success('Item edited successfully');
				setShow({ input: false, details: true });
				refetch();
			} else {
				toast.error('Failed to edit the item');
			}
		} catch (error) {
			toast.error('Error while editing the item');
			console.error(error);
		}
	};

	const handleAddNew = () => {
		setShow({ input: true, new: true });
		setSelected({
			name: '',
			shortName: '',
			category: '',
			type: 'text',
			width: [100, 200, 300, 400, 500],
			prefix: '',
			start: '',
			priority: 'Medium',
			needed: false,
		});
	};

	const handleDeclarationSave = () => {
    const declarationData = {
        type: 'declaration',
        text: seleted.declarationText,
        link: seleted.declarationLink,
    };
    const updatedDeclarations = [...(seleted?.declarations || []), declarationData];
    setSelected({ ...seleted, declarations: updatedDeclarations });
};

	const handleCertificateSave = () => {
		const certificateData = {
			id: Date.now(),
			type: 'certificate',
			name: seleted.certificate,
		};
		const updatedCertificates = [...(seleted?.certificates || []), certificateData];
		setSelected({ ...seleted, certificates: updatedCertificates });
	};

	const handleCheckboxOptionAdd = () => {
		const newOption = ''; // only value
		const updatedOptions = [...(seleted?.options || []), newOption];
		setSelected({ ...seleted, options: updatedOptions });
	};

	const handleCheckboxOptionDelete = (index) => {
		const updatedOptions = [...seleted.options];
		updatedOptions.splice(index, 1);
		setSelected({ ...seleted, options: updatedOptions });
	};

	const askForConfirmation = async (action) => {
		try {
			if (action === 'delete') {
				setShow({ delete: true });
			} else if (action === 'update') {
				setShow({ update: true });
			} else if (action === 'new') {
				setShow({ new: true, update: true });
			} else {
				setShow({ details: true });
			}
		} catch (error) {
			toast.error('Error while asking for confirmation');
		}
	};
	const handleFilterChange = (key, value) => {
		setFilters((prev) => ({
			...prev,
			[key]: value,
		}));
	};

	if (isLoading) {
		return (
			<Main title='Individual Data Management' width={'100%'} height={'100%'}>
				<div className='flex justify-center items-center h-full'>
					<OLoading />
				</div>
			</Main>
		);
	}
	return (
		<Main title='Data Bank Management' width={'100%'} height={'100%'}>
			<Toaster />

			<div className='flex flex-col gap-6 overflow-y-auto h-full'>
				<div className='flex flex-wrap justify-between items-center gap-4 px-2'>
					<Button type='save' onClick={handleAddNew}>
						+ Add New
					</Button>

					{/* Roles Tabs */}
					<div className='flex flex-wrap gap-2'>
						{drops &&
							Object.keys(drops).map((key) => {
								const isActive = key === seletedRole;
								return (
									<div key={key} className={`px-3 py-1 rounded-md text-sm font-medium cursor-pointer transition-colors duration-200 ${isActive ? 'bg-primary text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} onClick={() => setSelectedRole(key)}>
										{key}
									</div>
								);
							})}
					</div>

					<div className='w-full sm:w-[250px]'>
						<input type='text' value={searchText} onChange={(e) => setSearchText(e.target.value)} className='w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500' placeholder='Search...' />
					</div>
					<Button type='close' onClick={onClose}>
						Close
					</Button>
				</div>
				<Table className='w-full' innerWidth={['5%', '25%', '20%', '20%', '25%', '5%']}>
					<Thead>
						<Tr>
							<Th width='5%'>Sl.No.</Th>
							{columns.map(({ key, label, filterType, options }) => (
								<Th key={key} className='text-left' width='20%' padding='0'>
									{filterType === 'select' ? (
										<div className='flex items-center h-[40px] m-0 p-0 rounded'>
											<select value={filters[key]} onChange={(e) => handleFilterChange(key, e.target.value)} className='w-full h-[40px]  bg-gray-800 text-white    '>
												<option value=''>All {label}</option>
												{options?.map((option) => (
													<option key={option} value={option}>
														{option}
													</option>
												))}
											</select>
										</div>
									) : (
										<div className='flex items-center h-[40px] m-0 p-3 rounded'>{key}</div>
									)}
								</Th>
							))}
							<Th width='10%'>Type</Th>
							<Th width='15%'>Manage</Th>
						</Tr>
					</Thead>

					<Tbody>
						{drops &&
							filteredData &&
							filteredData.length > 0 &&
							filteredData?.map((item, index) => (
								<Tr key={index} width='5%'>
									<Td>{index + 1}</Td>
									{['_id', 'name', 'shortName', 'category', 'type'].map((key) => {
										return (
											<Td width='20%' key={key} className='text-left'>
												{item[key]?.length > 20 ? item[key].slice(0, 20) + '...' : item[key]}
											</Td>
										);
									})}
									<Td width='20%'>
										<Button
											type='edit'
											onClick={() => {
												setShow({ details: true });
												handleSelect(item);
											}}>
											Manage
										</Button>
									</Td>
								</Tr>
							))}
					</Tbody>
				</Table>
			</div>

			{show.details && (
				<Main width='80%' height='80%' bgColor='#fff' title={`${seleted.name} Details`}>
					<div className='bg-white p-6 rounded-md shadow-sm h-full flex flex-col'>
						{/* Header */}
						<div className='flex justify-between items-center border-b pb-4 mb-4'>
							<h2 className='text-xl font-bold text-gray-800'>Details</h2>
							<Button type='close' onClick={() => handleClose('details')}>
								Close
							</Button>
						</div>

						{/* Details Grid */}
						<div className='grid grid-cols-1 lg:grid-cols-2 gap-y-4 gap-x-8 px-4 flex-grow overflow-y-auto'>
							{Object.keys(seleted).map((key) => (
								<div key={key} className='flex flex-col'>
									<span className='text-sm text-gray-500 font-medium capitalize'>{key}</span>
									<span className='text-base text-gray-800'>{Array.isArray(seleted[key]) ? seleted[key].join(', ') : typeof seleted[key] === 'object' && seleted[key] !== null ? JSON.stringify(seleted[key]) : seleted[key]?.toString()}</span>
								</div>
							))}
						</div>
						{seleted.type === 'array' && (
							<Button
								type='edit'
								onClick={() => {
									setShow({ array: true, details: true, input: true });
									setArrayCategory(seleted?.options);
								}}>
								Edit Array
							</Button>
						)}

						{/* Footer Actions */}
						<div className='flex justify-end gap-3 mt-6 border-t pt-4'>
							<Button type='edit' onClick={() => setShow({ input: true, delete: false })}>
								Edit
							</Button>
							<Button type='delete' onClick={() => askForConfirmation('delete')}>
								Delete
							</Button>
						</div>
					</div>
				</Main>
			)}
			{show.input && (
				<Main width='80%' height='80%' bgColor='#fff'>
					<div className='bg-white px-8 py-6 rounded-md shadow-sm h-full flex flex-col'>
						{/* Header */}
						<div className='flex justify-between items-center border-b pb-4 mb-6'>
							<h2 className='text-xl font-bold text-gray-800'>Input</h2>
							<Instruction keyId={'dataBank'} />
							<Button type='close' onClick={() => handleClose('input')}>
								Close
							</Button>
						</div>

						{/* Input Grid */}
						<div className='grid grid-cols-1 md:grid-cols-2 gap-6 px-4 overflow-y-auto flex-grow'>
							<div className='flex flex-col gap-1'>
								<Input2 type='text' state={seleted} returnKey={'_id'} fieldName='_id' setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
							</div>
							<div className='flex flex-col gap-1'>
								<Input2 type='text' state={seleted} returnKey={'name'} fieldName='name' setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
							</div>
							<div className='flex flex-col gap-1'>
								<Input2 type='date' state={seleted} returnKey={'start'} fieldName='start' setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
							</div>
							<div className='flex flex-col gap-1'>
								<Input2 type='drop' state={seleted} returnKey={'priority'} fieldName='priority' options={['Emergency', 'High', 'Medium', 'Low']} setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
							</div>
							<div className='flex flex-col gap-1'>
								<Input2 type='date' state={seleted} returnKey={'end'} fieldName='end' setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
							</div>
							<div className='flex flex-col gap-1'>
								<Input2 type='text' state={seleted} returnKey={'shortName'} fieldName='shortName' setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
							</div>

							<div className='flex flex-col gap-1'>
								<Input2 type='text' state={seleted} isArray={true} fieldName='width-1' arrayName='width' inputValue={'width'} indexVal={0} setState={setSelected} />
								<Input2 type='text' state={seleted} isArray={true} fieldName='width-2' arrayName='width' inputValue={'width'} indexVal={1} setState={setSelected} />
								<Input2 type='text' state={seleted} isArray={true} fieldName='width-3' arrayName='width' inputValue={'width'} indexVal={2} setState={setSelected} />
								<Input2 type='text' state={seleted} isArray={true} fieldName='width-4' arrayName='width' inputValue={'width'} indexVal={3} setState={setSelected} />
								<Input2 type='text' state={seleted} isArray={true} fieldName='width-5' arrayName='width' inputValue={'width'} indexVal={4} setState={setSelected} />
							</div>
							<div className='flex flex-col gap-1'>
								<Input2 type='drop' state={seleted} returnKey={'whoFill'} fieldName='whoFill' options={seletedRole == 'student' || seletedRole == 'scholars' ? ['user', 'teacher', 'office'] : seletedRole == 'teacher' ? ['user', 'office'] : ['user']} setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
								<Input2 type='bool' state={seleted} returnKey={'needed'} fieldName='needed' setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
								<Input2 type='text' state={seleted} returnKey={'prefix'} fieldName='prefix' setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
								<Input2 type='drop' state={seleted} returnKey={'category'} fieldName='category' options={[...selectedRoleCategory, 'other']} setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
								{!selectedRoleCategory.includes(seleted.category) && <Input2 type='text' state={seleted} returnKey={'category'} fieldName='category' setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />}

								<Input2 type='drop' state={seleted} returnKey={'type'} fieldName='type' options={['text', 'phone', 'date', 'array', 'dropdown', 'number', 'email', 'checkbox', 'declaration', 'certificate','dateMonthYear']} setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />

								{seleted.type === 'dropdown' && (
									<div className='flex flex-col gap-1'>
										<ol>
											{seleted?.options?.map((item, index) => (
												<li key={index} className='flex gap-2'>
													<Input2 type='text' className='w-full' state={seleted} isArray={true} fieldName='options' arrayName='options' inputValue={'options'} indexVal={index} setState={setSelected} />
													<Button
														type='delete'
														onClick={() => {
															const updatedOptions = seleted?.options?.filter((_, i) => i !== index);
															setSelected({ ...seleted, options: updatedOptions });
														}}>
														Delete
													</Button>
												</li>
											))}
										</ol>
										<Button
											type='edit'
											onClick={() => {
												const updatedOptions = [...(seleted?.options || []), ''];
												setSelected({ ...seleted, options: updatedOptions });
											}}>
											Add Option
										</Button>
									</div>
								)}

								{seleted.type === 'array' && (
									<Button
										type='edit'
										onClick={() => {
											setShow({ array: true, details: true, input: true });
											setArrayCategory(seleted?.options);
										}}>
										Edit Array
									</Button>
								)}

								{seleted.type === 'checkbox' && (
									<div className='flex flex-col gap-1 col-span-full'>
										<h3 className='font-medium text-gray-700'>Checkbox Options</h3>
										<ol className='space-y-2'>
											{seleted?.options?.map((item, index) => (
												<li key={index} className='flex gap-2 items-center'>
													<span className='text-sm text-gray-500 min-w-[20px]'>{index + 1}.</span>
													<Input2
														type='text'
														className='flex-1'
														state={seleted}
														isArray={true}
														returnKey={index} // 👈 this is key for string array
														arrayName='options'
														indexVal={index}
														inputValue={item}
														setState={setSelected}
														placeholder={`Option ${index + 1}`}
													/>
													<Button type='delete' onClick={() => handleCheckboxOptionDelete(index)}>
														Delete
													</Button>
												</li>
											))}
										</ol>

										<div className='flex gap-2 mt-2'>
											<Button type='save' onClick={handleCheckboxOptionAdd}>
												Add Option checkbox
											</Button>
										</div>
									</div>
								)}

								{seleted.type === 'declaration' && (
									<div className='flex flex-col gap-1 col-span-full'>
										<Input2 type='text' state={seleted} returnKey={'declarationText'} fieldName='Add Declaration text' setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
										<Input2 type='text' state={seleted} returnKey={'declarationLink'} fieldName='Add External Website link' setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
										<Button type='save' onClick={handleDeclarationSave}>
											Save
										</Button>
									</div>
								)}

								{seleted.type === 'certificate' && (
									<div className='flex flex-col gap-1 col-span-full'>
										<Input2 type='text' state={seleted} returnKey={'certificate'} fieldName='name of certicate' setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
										<Button type='save' onClick={handleCertificateSave}>
											Save
										</Button>
									</div>
								)}
							</div>
						</div>

						{/* Footer Actions */}
						<div className='flex justify-end gap-3 mt-6 border-t pt-4'>
							<Button type='save' onClick={() => askForConfirmation(show?.new ? 'new' : 'update')}>
								Save
							</Button>
							<Button type='delete' onClick={() => handleClose('input')}>
								Cancel
							</Button>
						</div>
					</div>
				</Main>
			)}

			{show.delete && (
				<Main>
					<div className='flex flex-col gap-4'>
						<div className='flex justify-between items-center'>
							<div className='text-lg font-semibold'>Delete</div>
							<Button
								type='close'
								onClick={() => {
									handleClose('delete');
								}}>
								Close
							</Button>
						</div>
						<div className='text-sm'>Are you sure you want to delete this item?</div>
					</div>
					<div className='flex justify-end mt-4'>
						<Button
							type='delete'
							onClick={() => {
								handleClose('delete');
								handleDelete();
							}}>
							Yes
						</Button>
						<Button type='edit' onClick={() => handleClose('delete')}>
							No
						</Button>
						<div className='flex justify-end gap-3 mt-6 border-t pt-4'>
							<Button type='save' onClick={handleEdit}>
								{show.new ? 'Create' : 'Save Changes'}
							</Button>
							<Button type='close' onClick={() => handleClose('input')}>
								Cancel
							</Button>
						</div>
					</div>
				</Main>
			)}
			{show.update && (
				<Main>
					<div className='flex flex-col gap-4'>
						<div className='flex justify-between items-center'>
							<div className='text-lg font-semibold'>{show?.new ? 'Add New' : 'Update'}</div>
							<div></div>
						</div>
						<div className='text-sm'>Are you sure you want to {show?.new ? 'Add' : 'update'} this item?</div>
					</div>
					<div className='flex justify-end mt-4'>
						<Button type='save' onClick={() => handleEdit(seleted)}>
							Yes
						</Button>
						<Button type='edit' onClick={() => handleClose('update')}>
							No
						</Button>
					</div>
				</Main>
			)}
			{show.array && show.input && (
				<Main width='80%' height='80%' bgColor='#fff'>
					<div className='bg-white px-8 py-6 rounded-md shadow-sm h-full flex flex-col'>
						<ArrayDataBank close={handleClose} state={arraycategory} setState={setArrayCategory} setOrg={setSelected} />
					</div>
				</Main>
			)}
		</Main>
	);
}

const ArrayDataBank = ({ close, state, setState, setOrg }) => {
	const [openModal, setOpenModal] = useState(false);
	const [seleted, setSelected] = useState({});
	const handleAddUpdate = () => {
		const currentList = state || [];
		const exists = currentList?.some((x) => x._id === seleted._id);
		const settings = exists ? currentList?.map((item) => (item._id === seleted._id ? { ...seleted } : item)) : [...currentList, seleted];
		setState(settings);
		setOpenModal(false);
		setSelected({
			name: '',
			shortName: '',
			category: '',
			type: 'text',
			width: [100, 200, 300, 400, 500],
			prefix: '',
			start: '',
			priority: 'Medium',
			needed: false,
		});
	};
	return (
		<div className=' w-full overflow-y-scroll'>
			<div className='flex col w-full justify-between'>
				<div className='flex col gap-2'>
					<Button
						type='edit'
						onClick={() => {
							setOrg((e) => {
								return { ...e, options: state };
							});
							close('array');
						}}>
						Close
					</Button>
					<Button
						type='save'
						onClick={() => {
							setSelected({});
							setOpenModal(true);
						}}>
						+ Add
					</Button>
				</div>
				<Button
					type='save'
					onClick={() => {
						setOrg((e) => {
							return { ...e, options: state };
						});
						close('array');
					}}>
					Save
				</Button>
			</div>
			<Table className='w-full'>
				<Thead>
					<Tr>
						<Th width={'100px'}>Sl.No.</Th>
						{['_id', 'name', 'shortName'].map((key) => (
							<Th key={key} className='text-left' width={'200px'}>
								{key}
							</Th>
						))}
						<Th width={'100px'}>Manage</Th>
					</Tr>
				</Thead>
				<Tbody>
					{state &&
						state.map((item, index) => (
							<Tr key={index}>
								<Td width={'100px'}>{index + 1}</Td>
								{['_id', 'name', 'shortName'].map((key) => {
									return (
										<Td key={key} className='text-left' width={'200px'}>
											{item[key]?.length > 20 ? item[key].slice(0, 20) + '...' : item[key]}
										</Td>
									);
								})}
								<Td width={'100px'}>
									<Button
										type='edit'
										onClick={() => {
											setSelected(item);
											setOpenModal(true);
										}}>
										Manage
									</Button>
								</Td>
							</Tr>
						))}
				</Tbody>
			</Table>
			{openModal && (
				<Main width='80%' height='80%' bgColor='#fff'>
					<div className='bg-white px-8 py-6 rounded-md shadow-sm h-full flex flex-col'>
						{/* Header */}
						<div className='flex justify-between items-center border-b pb-4 mb-6'>
							<h2 className='text-xl font-bold text-gray-800'>Input</h2>
							<Button
								type='close'
								onClick={() => {
									setOpenModal(false);
								}}>
								Close
							</Button>
						</div>

						{/* Input Grid */}
						<div className='grid grid-cols-1 md:grid-cols-2 gap-6 px-4 overflow-y-auto flex-grow'>
							<div className='flex flex-col gap-1'>
								<Input2 type='text' state={seleted} returnKey={'name'} fieldName='name' setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
							</div>
							<div className='flex flex-col gap-1'>
								<Input2 type='drop' state={seleted} returnKey={'priority'} fieldName='priority' options={['Emergency', 'Medium', 'Low']} setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
							</div>
							<div className='flex flex-col gap-1'>
								<Input2 type='text' state={seleted} returnKey={'_id'} fieldName='_id' setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
								<Input2 type='text' state={seleted} returnKey={'shortName'} fieldName='shortName' setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
								<Input2 type='drop' state={seleted} returnKey={'type'} fieldName='type' options={['text', 'number', 'date', 'array', 'dropdown', 'email']} setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
								{seleted.type === 'dropdown' && (
									<div className='flex flex-col gap-1'>
										<ol>
											{seleted?.options?.map((item, index) => (
												<li key={index} className='flex gap-2'>
													<Input2 type='text' className='w-full' state={seleted} isArray={true} fieldName='options' arrayName='options' inputValue={'options'} indexVal={index} setState={setSelected} />
													<Button
														type='delete'
														onClick={() => {
															const updatedOptions = seleted?.options?.filter((_, i) => i !== index);
															setSelected({ ...seleted, options: updatedOptions });
														}}>
														Delete
													</Button>
												</li>
											))}
										</ol>
										<Button
											type='edit'
											onClick={() => {
												const updatedOptions = [...(seleted?.options || []), ''];
												setSelected({ ...seleted, options: updatedOptions });
											}}>
											Add Option
										</Button>
									</div>
								)}

								<Input2 type='text' state={seleted} returnKey={'prefix'} fieldName='prefix' setState={setSelected} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
							</div>
							<div className='flex flex-col gap-1'>
								<Input2 type='text' state={seleted} isArray={true} fieldName='width' arrayName='width' inputValue={'width'} indexVal={0} setState={setSelected} />
								<Input2 type='text' state={seleted} isArray={true} fieldName='width' arrayName='width' inputValue={'width'} indexVal={1} setState={setSelected} />
								<Input2 type='text' state={seleted} isArray={true} fieldName='width' arrayName='width' inputValue={'width'} indexVal={2} setState={setSelected} />
								<Input2 type='text' state={seleted} isArray={true} fieldName='width' arrayName='width' inputValue={'width'} indexVal={3} setState={setSelected} />
								<Input2 type='text' state={seleted} isArray={true} fieldName='width' arrayName='width' inputValue={'width'} indexVal={4} setState={setSelected} />
							</div>
						</div>
						<Button
							type='save'
							onClick={() => {
								handleAddUpdate();
							}}>
							Save
						</Button>
					</div>
				</Main>
			)}
		</div>
	);
};

export default DataBank;
